

import React, {useState} from 'react';
import {Form, Input, Button, Checkbox, Layout, Alert, message, Space, Select} from 'antd';
import {createBrowserRouter, Navigate, RouterProvider, useLocation} from "react-router-dom";
import Cookies from 'js-cookie';

import {NavLink, Routes, Route} from 'react-router-dom'

import {useNavigate} from 'react-router-dom';
import JSEncrypt from "jsencrypt";
import '../../auth.css';

let auto_address = '';

if (true) {

    auto_address = 'https://keyactive.leytcn.com/api/';
} else {
    auto_address = 'http://localhost:3000 ';

}


const Project_LoginForm: React.FC = () => {

    document.title='登录'
    const navigate = useNavigate();
    const url = useLocation();
    const url_data = new URLSearchParams(url.search)


    const url_value_return_url=url_data.get('return_url')


    const [encryptedData, setEncryptedData] = useState('');

    // 公钥内容（从后端或配置文件中获取
    const publicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAiH6ua1HAE/jXVfIaKk6s
1P3KO6dLw4wCVXcBlBBFDMIrvt4J5I9mnNoFGcoLxI3ttHLHg9Ep5qBmdUmfn5LL
K0TJqwCE6nXJJagig89Nc22pOpcOPpF6R984ccFhwvgJiBrOW3gfhF5ALNVhwXsB
kUSByDlk7fnGjqD42n9S9KfGj+GKQ6gKR8Yw+1L2n2VgJ/4Pafc5/rE59uPnDKwL
z+QG+nGndH4PG9pm68jXHcBUfm6pUKO9Uczz1fmS+pV5AAf44ZRlCw6+QSstIs23
ADwprQjPvN/msrRV+QQAxd/Eoa1geeh36c+Nb8nubRSTgaQnXdZLR+PqvNMsoYUV
IwIDAQAB
-----END PUBLIC KEY-----
`;
    const onFinish = async (values: any) => {

        const dataToEncrypt = values.user_password;
        const encryptor = new JSEncrypt();
        encryptor.setPublicKey(publicKey); // 设置公钥
        const encrypted = encryptor.encrypt(dataToEncrypt); // 加密数据

        const login_body=new FormData();



        login_body.append('user_name',values.user_name)
        login_body.append('user_password',String(encrypted))
        login_body.append('phone_number',values.phone_number)

        // PHP 后端发送登录请求
        const response = await fetch('https://chatv2.leytcn.com/api/login/project/projectlogin.php', {
            method: 'POST',
            headers: {

            },
            body: login_body,
        });

        const result = await response.json();
        //    console.log(result)

        switch (result.message){

            case 2000:


                let num = 12 //失效时间是几小时
                let time = new Date(new Date().getTime() + num * 60 * 60 * 1000);

                Cookies.set('userToken_chattool', result.info.user_access_info, {expires: time})
                message.success('登录成功',3)




                if(url_value_return_url!==''&&url_value_return_url!==null&&url_value_return_url!==undefined){

                    window.location.href = String(url_value_return_url)

                }
                else {


                    window.location.href = '/project/projectmanagement'



                }


                Cookies.set('group','projectadmin')








                break;

            case 2001:


                message.error(result.value);

                break;

            case 202:


                message.error(result.value);

                break;


        }



    };




    /*
    useEffect(() => {
        function handleResize() {
            setScreenResolution({ width: window.innerWidth, height: window.innerHeight });
        }

        // 初始化时获取一次屏幕分辨率
        handleResize();

        // 监听窗口大小变化事件
        window.addEventListener('resize', handleResize);

        // 清除监听
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    */



    return (






        <div className="auth-project-bg">
            <div style={{float:'right',marginRight:130,marginTop:200,backgroundColor:'#ffffff',padding:20,borderRadius:10}}>


                <h4 style={{marginTop: 25}}>项目管理
                </h4>
                <Form
                    name="loginForm"
                    initialValues={{remember: true}}
                    onFinish={onFinish}
                    style={{width: 230, marginTop: 20}}
                >

                    <Form.Item
                        name="user_name"
                        rules={[{required: true, message: 'Please input your username!'}]}
                    >
                        <Input placeholder="Username"/>
                    </Form.Item>

                    <Form.Item
                        name="user_password"
                        rules={[{required: true, message: 'Please input your password!'}]}
                    >
                        <Input.Password placeholder="Password"/>
                    </Form.Item>

                    <Form.Item
                        name="phone_number"
                        rules={[{required: true, message: 'Please input your country_code!'}]}
                    >
                        <Input placeholder="phone number"/>
                    </Form.Item>



                    <Form.Item name="remember" valuePropName="checked">
                        <Checkbox>Remember me</Checkbox>
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" style={{width: '100%'}}>
                            Log in
                        </Button>
                    </Form.Item>
                </Form>


            </div>

        </div>

    );


};

export default Project_LoginForm;



